(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-hero-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SELECTOR = '[data-aa-carousel]';
    const SWIPE_THRESHOLD = 40;

    function init(root) {
      if (!root || root.dataset.aaInit === '1') return;
      root.dataset.aaInit = '1';

      const slides = Array.from(root.querySelectorAll('[data-aa-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-aa-dot]'));
      const prevBtn = root.querySelector('[data-aa-prev]');
      const nextBtn = root.querySelector('[data-aa-next]');
      const pauseBtn = root.querySelector('[data-aa-pause]');
      const viewport = root.querySelector('[data-aa-viewport]');

      if (slides.length <= 1) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      const autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 5000;
      const transitionMs = parseInt(root.dataset.transitionMs, 10) || 800;
      const pauseOnHover = root.dataset.pauseOnHover === 'true';

      let current = slides.findIndex((s) => s.classList.contains('is-active'));
      if (current < 0) current = 0;
      let timer = null;
      let leavingTimer = null;
      let userPaused = false;
      let hovered = false;
      let focused = false;
      let visible = true;

      function setSlideTabindex(slide, value) {
        const items = slide.querySelectorAll('a, button');
        items.forEach((el) => el.setAttribute('tabindex', value));
      }

      function setSlide(next) {
        next = ((next % slides.length) + slides.length) % slides.length;
        if (next === current) return;

        const prev = slides[current];
        const target = slides[next];

        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        prev.setAttribute('aria-hidden', 'true');
        setSlideTabindex(prev, '-1');

        target.classList.add('is-active');
        target.classList.remove('is-leaving');
        target.setAttribute('aria-hidden', 'false');
        setSlideTabindex(target, '0');

        dots.forEach((dot, i) => {
          const active = i === next;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) {
            const ring = dot.querySelector('.aa-hero-carousel__dot-progress');
            if (ring) {
              ring.style.animation = 'none';
              void ring.offsetWidth;
              ring.style.animation = '';
            }
          }
        });

        if (leavingTimer) window.clearTimeout(leavingTimer);
        leavingTimer = window.setTimeout(function () {
          prev.classList.remove('is-leaving');
        }, transitionMs + 50);

        current = next;
      }

      function next() { setSlide(current + 1); }
      function prev() { setSlide(current - 1); }

      function shouldRun() {
        return autoplay && !userPaused && visible && !(pauseOnHover && hovered) && !focused;
      }

      function applyPausedAttr() {
        root.dataset.paused = shouldRun() ? 'false' : 'true';
      }

      function startTimer() {
        stopTimer();
        if (!shouldRun()) { applyPausedAttr(); return; }
        applyPausedAttr();
        timer = window.setInterval(next, autoplayMs);
      }

      function stopTimer() {
        if (timer) { window.clearInterval(timer); timer = null; }
        applyPausedAttr();
      }

      if (nextBtn) nextBtn.addEventListener('click', () => { focused = false; next(); startTimer(); });
      if (prevBtn) prevBtn.addEventListener('click', () => { focused = false; prev(); startTimer(); });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          if (!Number.isNaN(idx)) { focused = false; setSlide(idx); startTimer(); }
        });
      });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          if (userPaused) stopTimer(); else startTimer();
        });
      }

      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); startTimer(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); startTimer(); }
      });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', () => { hovered = true; startTimer(); });
        root.addEventListener('mouseleave', () => { hovered = false; startTimer(); });
      }
      root.addEventListener('focusin', () => { focused = true; startTimer(); });
      root.addEventListener('focusout', (e) => {
        if (!root.contains(e.relatedTarget)) { focused = false; startTimer(); }
      });

      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerActive = false;
      let pointerMoved = false;
      if (viewport) {
        viewport.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          pointerActive = true;
          pointerMoved = false;
          pointerStartX = e.clientX;
          pointerStartY = e.clientY;
        });
        viewport.addEventListener('pointermove', (e) => {
          if (!pointerActive) return;
          if (Math.abs(e.clientX - pointerStartX) > 6 || Math.abs(e.clientY - pointerStartY) > 6) {
            pointerMoved = true;
          }
        });
        viewport.addEventListener('pointerup', (e) => {
          if (!pointerActive) return;
          pointerActive = false;
          const dx = e.clientX - pointerStartX;
          const dy = e.clientY - pointerStartY;
          if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) next(); else prev();
            startTimer();
          }
        });
        viewport.addEventListener('pointercancel', () => { pointerActive = false; });
        viewport.addEventListener('dragstart', (e) => { e.preventDefault(); });
        viewport.addEventListener('click', (e) => {
          if (pointerMoved) {
            e.preventDefault();
            e.stopPropagation();
            pointerMoved = false;
          }
        }, true);
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { visible = entry.isIntersecting; startTimer(); });
        }, { threshold: 0.2 });
        io.observe(root);
      }

      document.addEventListener('visibilitychange', () => {
        visible = !document.hidden;
        startTimer();
      });

      startTimer();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
